export default __webpack_public_path__ + "static/media/parthner-medicina-practica.dfe04b26.png";